"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Exports_1 = require("../common.browser/Exports");

var Exports_2 = require("../sdk/Exports");

var Exports_3 = require("./Exports");

var TestHooksParamName = "testhooks";
var ConnectionIdHeader = "X-ConnectionId";

var TranslationConnectionFactory =
/** @class */
function () {
  function TranslationConnectionFactory() {
    this.create = function (config, authInfo, connectionId) {
      var endpoint = config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_Endpoint, undefined);

      if (!endpoint) {
        var region = config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_Region, undefined);
        endpoint = "wss://" + region + ".s2s.speech.microsoft.com/speech/translation/cognitiveservices/v1";
      }

      var queryParams = {
        from: config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_RecoLanguage),
        to: config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_TranslationToLanguages)
      };
      var voiceName = "voice";
      var featureName = "features";

      if (config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_TranslationVoice, undefined) !== undefined) {
        queryParams[voiceName] = config.parameters.getProperty(Exports_2.PropertyId.SpeechServiceConnection_TranslationVoice);
        queryParams[featureName] = "texttospeech";
      }

      var headers = {};
      headers[authInfo.headerName] = authInfo.token;
      headers[ConnectionIdHeader] = connectionId;
      return new Exports_1.WebsocketConnection(endpoint, queryParams, headers, new Exports_3.WebsocketMessageFormatter(), Exports_1.ProxyInfo.fromRecognizerConfig(config), connectionId);
    };
  }

  return TranslationConnectionFactory;
}();

exports.TranslationConnectionFactory = TranslationConnectionFactory;